exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title-section{margin-top:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-0e8f68d0!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/ProductAttribute/productDetail.vue
// module id = 843
// module chunks = 2